import namespace from '../upi/namespace';
import AppController from './views/appController';
import AppRouter from './routes/appRouter';
import PageController from './views/pageController';

// Analytics tracking
import dataLayer from '@root/src/scripts/upi/data-layer';

var app = namespace( 'apps.productpage' ),

    initialize = function () {
        const contentEl = document.getElementById( 'body-content' );
        if ( contentEl ) {
            contentEl.classList.add( 'initializing' );
        }

        // console.log( 'Model', app.ProductModel );
        app.mediator = _.extend( {}, Backbone.Events, {
            willTrigger: function ( evName ) {
                return function () {
                    this.trigger( evName, arguments );
                }.bind( this );
            }
        } );

        AppRouter.initialize();

        app.pageController = new PageController();
        app.appController = new AppController( dataLayer );
    },

    destroy = function () {
        app.mediator.unbind();
        app.pageController.close();
        app.appController.close();

        delete app.mediator;
        delete app.pageController;
        delete app.appController;
    };

export default {
    initialize,
    destroy
};
